import axios from 'axios';
import { AppConfig } from '../config/app'
import { RouteHistory } from './route-provider';
import GlobalStore from './global-store-provider';
import { showError } from '../components/common/libs/helpers';
//Init API

axios.defaults.baseURL = AppConfig.api;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, function (error) {
  if (typeof (error.response) !== 'undefined' && error.response.status === 401) {
    /* if (RouteHistory)
      RouteHistory.push('/logout') */
  }
  if (typeof (error.response) !== 'undefined' && error.response.status === 500 && error.response.data) {
    showError(error.response.data.message);
  } else if (typeof (error.response) !== 'undefined' && error.response.status < 200)
    showError('Check your internet please', 'error');
  // Do something with response error
  return Promise.reject(error);
});

//###Export API###
//Data API
export const DataApi = {
  getGrid(url, pageSize, page, sorted, filtered) {
    return axios.get(url + '?' + serialize({ grid: true, pageSize: pageSize, page: page, sorted: JSON.stringify(sorted), filtered: JSON.stringify(filtered) }));
  },
  getSelect(url, filters) { if (!filters) filters = {}; filters.select = true; return axios.get(url + (url.indexOf('?') === -1 ? '?' : '&') + serialize(filters)); },
  getMany(url, filters) { return axios.get(url + (filters ? '?' + serialize(filters) : '')) },
  getOne(urlWithId, lock, localize = true) {
    let config = { headers: { 'Localized': localize } };
    if (lock)
      config.headers['Lock-Resource'] = true;
    return axios.get(urlWithId, config);
  },
  create(url, data, headers) {
    let config = { headers: { 'Localized': false } };
    if (headers)
      config.headers = { ...config.headers, ...headers }
    return axios.post(url, data, config)
  },
  update(urlWithId, data, headers) {
    let config = { headers: { 'Localized': false } };
    if (headers)
      config.headers = { ...config.headers, ...headers }
    return axios.put(urlWithId, data, config);
  },
  delete(urlWithId) {
    let config = { headers: { 'Localized': false } };
    return axios.delete(urlWithId, config);
  },
  uploadImage(file, editor, config) {
    if (!config)
      config = { headers: { 'Content-Type': 'multipart/form-data' } };
    let fd = new FormData();
    fd.append('file', file);
    return axios.post('upload/image' + (editor ? '/editor' : ''), fd, config);
  },
  uploadFile(file, config) {
    let fd = new FormData();
    fd.append('file', file);
    return axios.post('upload/file', fd, config);
  },

}
//Authoriztion API
export const AuthApi = {
  login(email, password, recaptcha) { return axios.post('auth/login', { email: email, password: password, recaptcha: recaptcha }); },
  logout() { return axios.get('auth/logout'); },
  register(data) { return axios.post('auth/signup', data); },
  completeProfile(data) { return axios.post('auth/complete-profile', data); },
  sendFcmToken(token) { return axios.post('notifications/token', { token: token }); },
  resetPasswordRequest(email) { return axios.post('password/create', { email: email }); },
  resetPasswordFind(token) { return axios.get('password/find/' + token); },
  resetPassword(data) { return axios.post('password/reset', data); },
  chooseRole(data) { return axios.post('auth/change-role', { role: data }); },


}
//Helper
const serialize = function (obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}
